
<div v-show="visible" class="mouse-follower text-uppercase p-2" :style="coords" v-text="targetName"></div>
